import { useState } from "react";
import { ExternalLink, Loader2 } from "lucide-react";
import { PUNTOENVIO } from "../../lib/site";

export const QuoteTool = () => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div data-testid="quote-tool" className="rounded-[28px] bg-[var(--paper)] p-4 text-[var(--ink)] md:p-6">
      <div className="flex flex-wrap items-center justify-between gap-3 px-2 pb-4">
        <p className="font-display text-3xl md:text-4xl">Cotizá tu encomienda</p>
        <a href={PUNTOENVIO.quoteUrl} target="_blank" rel="noopener noreferrer" data-testid="quote-open-puntoenvio" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--forest)] hover:underline">
          Abrir en puntoenvio.com <ExternalLink className="h-4 w-4" />
        </a>
      </div>
      <div className="relative overflow-hidden rounded-2xl bg-white">
        {!loaded && <div className="absolute inset-0 grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-[var(--muted-ink)]" /></div>}
        <iframe data-testid="quote-iframe" title="Cotizador PuntoEnvío" src={PUNTOENVIO.quoteUrl} onLoad={() => setLoaded(true)} loading="lazy" className="h-[820px] w-full border-0" />
      </div>
    </div>
  );
};
